import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import Loading from '../Components/Loading';
import { addPark } from '../Redux/actions';
import { getParkSelector } from '../Redux/selectors';
import { isDataPopulated } from '../utils';

export const WithParkData = ({ children }) => {
  const { pid } = useParams();
  const dispatch = useDispatch();
  const parkData = useSelector(getParkSelector(pid));
  const hasAnyData = isDataPopulated(parkData);
  const [hasData, setHasData] = useState(hasAnyData);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchParkData = async () => {
      // Only fetch if park data isn't already in Redux
      if (!parkData || Object.keys(parkData).length === 0) {
        try {
          const res = await fetch(`/json/PARKDETAILS-${pid}.json`, { signal: controller.signal });
          if (!res.ok) throw new Error(`HTTP error, status = ${res.status}`);
          const data = await res.json();
          if (isMounted) addPark(dispatch, pid, data);
        } catch (err) {
          if (isMounted) console.error('Error fetching park data:', err);
        } finally {
          if (isMounted) setHasData(true);
        }
      } else {
        setHasData(true);
      }
    };

    fetchParkData();

    return () => {
      isMounted = false;
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pid]);

  return hasData ? children : <Loading />;
};
